/* Maison Katwil — interacciones mínimas */
(function () {
  // Menú móvil
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.toggle('is-open'); });
  }

  // Barra de compra fija (móvil) -> envía el formulario de producto
  var sticky = document.querySelector('[data-sticky-buy]');
  var form = document.querySelector('[data-product-form]');
  if (sticky && form) {
    sticky.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
  }

  // Galería: miniaturas cambian la imagen principal (escritorio)
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (main) main.src = t.dataset.full || t.src;
    });
  });
})();
